import { useEffect } from 'react'
import PropTypes from 'prop-types'
import useSaveProgress, { verifyUrl } from 'common/video/plugins/use-save-progress'
import { VideoIframe } from 'common/video-responsive'

function Vimeo({ progress_time, url_vimeo }) {
  const { iframe } = useSaveProgress({ progress_time, url_vimeo })

  useEffect(() => {
    console.log('component mounted', url_vimeo)
  }, [])

  const url = verifyUrl(url_vimeo)
  return (
    <>
      <VideoIframe
        position="static"
        isLesson
        key={url}
        id="video-player"
        element={iframe}
        src={`https://player.vimeo.com/video/${url}?autoplay=true&byline=false&controls=true&title=false&dnt=true&muted=1&pip=1`}
      />
    </>
  )
}

Vimeo.propTypes = {
  progress_time: PropTypes.number.isRequired,
  url_vimeo: PropTypes.string.isRequired,
}

export default Vimeo
